import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { getCurrentLeg } from '../../../selectors/screen';
import { getLegWorkInfo } from '../../../selectors/sended-data';

export const useSummaryData = () =>
    useSelector((state) => {
        const leg = useSelector(getCurrentLeg) || {};
        const isCrewInfoRequired = get(state.routesDeclaration, 'options.isCrewInfoRequired', false);
        const legInfo = getLegWorkInfo(state.sendedData, leg.id);
        const isLegSummaryData = legInfo && legInfo.startWorkTime && legInfo.workTime;
        const currentLeg = state.sendedData[leg.id];
        const isCrewInfo = currentLeg && currentLeg.bufferCrew && Object.keys(currentLeg.bufferCrew).length > 0;

        return {
            isLegSummaryData,
            isLegSummaryDataSended: isLegSummaryData && ((isCrewInfoRequired && isCrewInfo) || !isCrewInfoRequired),
        };
    });
